import { useState, useCallback } from 'react';
import type { TrackingFilters, StatusFilter, LocationStatusFilter, UseTrackingFiltersReturn } from '../types/tracking';
import { getTodayDateString } from '../utils/dateHelpers';

const initialFilters: TrackingFilters = {
  date: getTodayDateString(),
  programs: [],
  status: 'all',
  locationStatus: 'Active',
  searchQuery: '',
};

export function useTrackingFilters(): UseTrackingFiltersReturn {
  const [filters, setFilters] = useState<TrackingFilters>(initialFilters);

  const setDate = useCallback((date: string) => {
    setFilters(prev => ({ ...prev, date }));
  }, []);

  const toggleProgram = useCallback((program: string) => {
    setFilters(prev => {
      const exists = prev.programs.includes(program);
      return {
        ...prev,
        programs: exists
          ? prev.programs.filter(p => p !== program)
          : [...prev.programs, program],
      };
    });
  }, []);

  const setPrograms = useCallback((programs: string[]) => {
    setFilters(prev => ({ ...prev, programs }));
  }, []);

  const setStatus = useCallback((status: StatusFilter) => {
    setFilters(prev => ({ ...prev, status }));
  }, []);

  const setLocationStatus = useCallback((locationStatus: LocationStatusFilter) => {
    setFilters(prev => ({ ...prev, locationStatus }));
  }, []);

  const setSearchQuery = useCallback((searchQuery: string) => {
    setFilters(prev => ({ ...prev, searchQuery }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(initialFilters);
  }, []);

  return { filters, setDate, toggleProgram, setPrograms, setStatus, setLocationStatus, setSearchQuery, resetFilters };
}
